import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { GdprPortalDTO } from '../../../sb-tools/typescript/models/dto/gdpr-portal.dto';

@Injectable()
export class PortalService {
    constructor(private http: HttpClient) {}

    getPortal(name: string): Observable<GdprPortalDTO> {
        return this.http.get<GdprPortalDTO>(environment.apiInboxUrl + 'Community/GdprPortals/', {
            params: {
                name,
            },
        });
    }

    getPortals(): Observable<GdprPortalDTO[]> {
        return this.http.get<GdprPortalDTO[]>(environment.apiInboxUrl + 'Community/GdprPortals/');
    }
}
